
(function(template){
  define('vue!app/views/vue/components/packageDivComponent/packageScheduleComponent/bookForAllCheckBox',[
      "Vue",
      "helpers",
      "vuex"

  ], function (
      Vue,
      helpers,
      vuex, dropdown

  ) {
      return {
          template: template,
          name: "",
          props: [ 'service_id', 'username','count_time_bookable_for_all','uncheck_book_for_all'],
          data: function () {
              return {
              }
          },
          computed: _.extend(
              vuex.mapState(['users', 'bookForAllGuestCheckBox','activeUser','isFetching']), {
                isServiceBooked: function () {
                    if(this.username){
                      return this.users[this.username][this.service_id].SpaFolioItemId
                    }
                }



        }),
          methods:{
              FilterAvailability:function(){
                
                this.uncheck_book_for_all()
              }
          },


      }
  })
})('<!-- added extra <div> tag in order to fix the following compile error "Component template should contain exactly one root element. If you are using v-if on multiple elements, use v-else-if to chain them instead" --> <div> <template v-if="customization.alwaysShowSameTimeforallGuests"> <div class="bookForAllGuestCheckBoxWrapper" :class="singleBookingMode && !isServiceBooked && count_time_bookable_for_all > 0 ? \'\' : \'disabled\'"> <div @click="FilterAvailability" class="bookServiceAllUsers"> <div class=\'custom-check-box\'> <i v-show="bookForAllGuestCheckBox" class="fas fa-check"></i> </div> <span>{{ localStrings.stepper.body.schedule.heading.sameTimeForAll }}</span> </div> </div> </template> <template v-else> <div v-show="singleBookingMode && !isServiceBooked && count_time_bookable_for_all > 0"> <div @click="FilterAvailability" class="bookServiceAllUsers"> <div class=\'custom-check-box\'> <i v-show="bookForAllGuestCheckBox" class="fas fa-check"></i> </div> <span>{{ localStrings.stepper.body.schedule.heading.sameTimeForAll }}</span> </div> </div> </template> </div>');
